var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-xxl",attrs:{"id":"mainView"}},[_c('div',[_c('HeaderComponent')],1),_c('div',[_c('ContentComponent')],1),_c('div',{attrs:{"id":"paper"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }